export default __webpack_public_path__ + "static/media/lysningen-property-04.94812047.jpg";